import { EpicWinStep } from './epic_win_step';

export class EpicWinConfiguration {
  constructor(
    public readonly steps: EpicWinStep[],
    public readonly showCounterDelay: number,
    public readonly finishTextAnimationDelay: number,
    public readonly closePopupDelay: number,
    public readonly closeBySpace?: boolean
  ) {}
}
